import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderTopComponent } from './header-top.component';

@NgModule({
  declarations: [HeaderTopComponent],
  exports: [HeaderTopComponent],
  imports: [CommonModule, IonicModule],
})
export class HeaderTopComponentModule {}
